import React from "react";
import CommonInvoiceList from "../../../components/Invoice/CommonInvoiceList";

const PurchaseInvoiceList = () => {
    return (
        <CommonInvoiceList
            isSale={false}
            isPurchase={true}
            isRefund={false}
            pageName="Ön Muhasebe > Fiş / Faturalar > Alış Faturaları"
            pageVersion="4"
        />
    )
}

export default PurchaseInvoiceList;